import React from 'react';

export default function SelectDropdown({ options, onChange, id, className, emptyValueLabel, name, nameMapping }) {
    const updateValue = (value) => {
        const newOptions = [];

        for (let index = 0; index < options.length; index++) {
            const option = options[index];

            option.active = index === parseInt(value);

            newOptions.push(option);
        }

        onChange(options);
    };

    let selectedValue = '';
    for (let index = 0; index < options.length; index++) {
        if (options[index].active) {
            selectedValue = options[index].key;
            break;
        }
    }

    return (
        <select
            id={id}
            className={className}
            value={selectedValue}
            name={name}
            onChange={(event) => {
                updateValue(event.target.value);
            }}>
            <option value="">{emptyValueLabel}</option>
            {options.map((option, optionIndex) => {
                let name = null;
                if (nameMapping) {
                    name = nameMapping[option.name];
                } else {
                    name = option.name;
                }

                return (
                    <option value={option.key} key={optionIndex}>
                        {name}
                    </option>
                );
            })}
        </select>
    );
}
